<template>
    <div id="complianceAutomation" style="text-transform: capitalize">
        <div data-html2canvas-ignore="true" v-show="loader || spiderLoader">
            <Loader />
        </div>
        <div class="datepickerwrap card revampCard justify-content-between" style="flex-direction: row">
            <div class="w-75">
                <div class="leftcontent wrapitem">
                    <div class="datebox">
                        <datepicker placeholder="From" @input="changeCustomDate" v-model="startDate" />
                    </div>

                    <div class="datebox customSelect">
                        <select v-model="selected_website" class="form-control text-uppercase">
                            <optgroup label="Retail">
                                <!-- <option value="all">All</option> -->
                                <option value="https://www.amazon.com">Amazon US</option>
                                <option value="https://www.amazon.fr">Amazon France</option>
                                <option value="https://www.amazon.co.it">Amazon Italy</option>
                                <option value="https://www.amazon.es">Amazon Spain</option>
                                <option value="https://www.amazon.co.uk">Amazon UK</option>
                                <option value="https://www.amazon.de">Amazon Germany</option>
                                <option value="https://www.bestbuy.com">Best Buy US</option>
                                <option value="https://www.newegg.com">Newegg</option>
                                <option value="https://www.microcenter.com">Microcenter</option>
                                <option value="https://www.costco.com">Costco US</option>
                                <option value="https://www.currys.co.uk">Curry's UK</option>
                                <option value="https://www.harveynorman.com.au">Harvey Norman AU</option>
                                <option value="https://global.jd.com">JD GC</option>
                                <option value="https://www.mediamarkt.de">MediaMarkt DE</option>
                                <option value="https://www.walmart.com">Walmart US</option>
                            </optgroup>
                            <optgroup label="Consumer OEM">
                                <option value="https://br-store.acer.com">Acer Brazil</option>
                                <option value="https://store.acer.com/en-us">Acer US</option>
                                <option value="https://www.asus.com/fr">ASUS France</option>
                                <option value="https://store.asus.com/us">ASUS US</option>
                                <option value="https://www.dell.com/en-au">Dell Australia</option>
                                <option value="https://www.dell.com/ja-jp">Dell Japan</option>
                                <option value="https://www.dell.com/en-us">Dell US</option>
                                <option value="https://www.dell.com/en-uk">Dell UK</option>
                                <option value="https://fmv.fccl.fujitsu.com">Fujitsu Japan</option>
                                <option value="https://store.hp.com/FranceStore">HP France</option>
                                <option value="https://www8.hp.com/jp">HP Japan</option>
                                <option value="https://store.hp.com/mx-es">HP Mexico</option>
                                <option value="https://store.hp.com/UKStore">HP UK</option>
                                <option value="https://store.hp.com/us">HP US</option>
                                <option value="https://www.lenovo.com/au">Lenovo Australia</option>
                                <option value="https://s.lenovo.com.cn">Lenovo China</option>
                                <option value="https://www.lenovo.com/fr">Lenovo France</option>
                                <option value="https://www.lenovo.com/de">Lenovo Germany</option>
                                <option value="https://www.lenovo.com/gb">Lenovo UK</option>
                                <option value="https://www.lenovo.com/us">Lenovo US</option>
                                <option value="https://www.nec-lavie.jp">NEC Japan</option>
                            </optgroup>
                            <optgroup label="Commercial OEM">
                                <option value="https://www.hpstore.cn#commercial">
                                    Commercial HP China
                                </option>
                                <option value="https://store.hp.com/FranceStore#commercial">
                                    Commercial HP France
                                </option>
                                <option value="https://store.hp.com/GermanyStore#commercial">
                                    Commercial HP Germany
                                </option>
                                <option value="https://www8.hp.com/jp#commercial">
                                    Commercial HP Japan
                                </option>
                                <option value="https://store.hp.com/UKStore#commercial">
                                    Commercial HP UK
                                </option>
                                <option value="https://store.hp.com/us#commercial">Commercial HP US</option>
                                <option value="https://b2b.lenovo.com.cn#commercial">
                                    Commercial Lenovo China
                                </option>
                                <option value="https://www.lenovo.com/fr#commercial">
                                    Commercial Lenovo France
                                </option>
                                <option value="https://www.lenovo.com/de#commercial">
                                    Commercial Lenovo Germany
                                </option>
                                <option value="https://www.lenovo.com/jp#commercial">
                                    Commercial Lenovo Japan
                                </option>
                                <option value="https://www.lenovo.com/gb#commercial">
                                    Commercial Lenovo UK
                                </option>
                                <option value="https://www.lenovo.com/us#commercial">
                                    Commercial Lenovo US
                                </option>
                            </optgroup>
                            <optgroup label="Commercial Reseller">
                                <option value="https://www.bechtle.com">Bechtle</option>
                                <option value="https://www.cdw.com">CDW</option>
                                <option value="https://www.inmac-wstore.com">Inmac</option>
                                <option value="https://www.insight.com/en-US">Insight</option>
                                <option value="https://www.connection.com">PC Connection</option>
                                <option value="https://www.shi.com">SHI</option>
                                <option value="https://www.technoworld.com">TechnoWorld</option>
                            </optgroup>
                        </select>
                    </div>
                    <div class="datebox customSelect">
                        <select v-model="device" @change="refresh" class="form-control text-uppercase">
                            <option value="laptop">Laptop</option>
                            <option value="desktop">Desktop</option>
                            <option v-if="cpuGpuSites.includes(selected_website)" value="gpu">GPU</option>
                            <option v-if="cpuGpuSites.includes(selected_website)" value="cpu">CPU</option>
                        </select>
                    </div>
                    <div class="datebox">
                        <button @click="refresh" class="btn primarycolor" type="button">
                            <span>Submit</span>
                        </button>
                    </div>
                </div>
            </div>
            <div>
                <button @click="exportNow" class="btn primarycolor" type="button">
                    <span>Export</span>
                </button>
            </div>
        </div>
        <div class="mx-2 card revampCard d-flex justify-content-between flex-row">
            <div class="d-flex">
                <div v-if="Object.keys(logoMatchingStatus).length" class="d-flex">
                    <div class="mx-4 text-center">
                        <div class="" style="font-size: 16px; font-weight: 600; color: var(--primary_brand);">Status</div>
                        <div>{{ logoMatchingStatus.status }}</div>
                    </div>
                    <div class="mx-4 text-center" v-if="logoMatchingStatus.status === 'succeeded'">
                        <div class="" style="font-size: 16px; font-weight: 600; color: var(--primary_brand);">Logo Matching
                            Ended At</div>
                        <div>{{ logoMatchingStatus.match_end_time }}</div>
                    </div>
                    <div class="mx-4 text-center" v-if="logoMatchingStatus.status === 'running'">
                        <div class="" style="font-size: 16px; font-weight: 600; color: var(--primary_brand);">Estimated Time
                        </div>
                        <div>{{ logoMatchingStatus.estimated_time }}</div>
                    </div>
                    <div class="mx-4 text-center"
                        v-if="logoMatchingStatus.status === 'succeeded' || logoMatchingStatus.status === 'running'">
                        <div class="" style="font-size: 16px; font-weight: 600; color: var(--primary_brand);">Spider Ended
                            At</div>
                        <div>{{ logoMatchingStatus.spider_end_time }}</div>
                    </div>
                </div>
                <div v-else style="color: var(--red);">Status not available!</div>
            </div>
            <div class="float-right">
                <button @click="dumpData" class="btn primarycolor float-right" type="button">
                    <span>Dump</span>
                </button>
            </div>
        </div>
        <div class="container-fluid">
            <div class="card p-2 revampCard" v-if="rows_details.length">
                <div class="d-flex justify-content-end">
                    <div class="custom_dropdown customMultiselect mr-3" style="width:20%">
                        <multiselect v-model="selectedTranslateFields" :options="columns_details" :multiple="true"
                            placeholder="Select Field(s)" track-by="key" :searchable="false" label="label" select-label=""
                            deselect-label="" selectedLabel="" :closeOnSelect="false" open-direction="bottom">
                            <template slot="option" slot-scope="{ option }">
                                <div>
                                    <input type="checkbox" :value="option" v-model="selectedTranslateFields">
                                    <span class="option__title ml-3">{{ option.label }}</span>
                                </div>
                            </template>
                        </multiselect>
                    </div>
                    <div>
                        <button @click="translateData" class="btn primarycolor float-right" type="button">
                            <span>Translate</span>
                        </button>
                    </div>
                </div>
                <div class="mt-4">

                    <table id="compliance-automation-table" class="table" style="transform: rotateX(180deg)">
                        <thead class="thead-normal">
                            <tr>
                                <th v-for="d in columns_details" :key="d.key">{{ d.label }}</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tfoot style="display: table-row-group">
                            <tr>
                                <th v-for="d in columns_details" :key="d.key">{{ d.label }}</th>
                                <th></th>
                            </tr>
                        </tfoot>
                        <tbody class="tbody-normal">
                            <tr v-for="(r, i) in rows_details" :key="i" :class="{redbg: (!r.complete || !r.logo_matched)}">
                                <td v-for="d in columns_details" :key="d.key">
                                    <div v-if="isDataEditable && selectedItemID == i">
                                        <input type="checkbox"
                                            v-if="d.key === 'complete' || d.key === 'logo_matched' || d.key === 'review_scraped'"
                                            v-model="editedTableData[d.key]">
                                        <input type="text" v-else class="form-control form-control-sm" id="inputValue"
                                            :placeholder="d.label" v-model="editedTableData[d.key]" />
                                    </div>
                                    <div v-else>
                                        <span v-if="d.key == 'product_name'">
                                            <a target="_blank" :href="r['link']">{{ r[d.key] }}</a>
                                        </span>
                                        <span v-else>
                                            <span v-if="r[d.key] != ''">
                                                <span v-if="d.key == 'processor' && r['processor'] == 'amd'">{{
                                                    r[d.key].toUpperCase() }}</span>
                                                <span v-else :style="[
                                                    d.key == 'link' && { 'text-transform': 'lowercase' },
                                                ]">{{ r[d.key] }}</span>
                                            </span>
                                            <span v-else>-</span>
                                        </span>
                                    </div>
                                </td>
                                <td>
                                    <div class="row" style="
                            width: 90px;
                            margin: 0 0.5px;
                            display: flex;
                            justify-content: center;
                            gap: 8px;
                        ">
                                        <button type="button" class="form_button btn btn-secondary btn-sm"
                                            @click="processEditableTableData(r, i)">
                                            Edit
                                        </button>
                                        <button v-if="isDataEditable && selectedItemID == i"
                                            class="form_button btn btn-primary btn-sm ml-1" @click="saveEditedTableData(i)">
                                            Save
                                        </button>
                                        <button v-else type="button" class="form_button btn btn-danger btn-sm"
                                            @click="deleteTableRow(r)">
                                            Delete
                                        </button>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="card p-2 revampCard" v-else>
                <div class="w-90 card p-2 revampCard"
                    style="background-color: rgb(253, 242, 242); color: rgb(155, 28, 28); margin-bottom: 0 !important;">
                    No Data, try changing date or check the status.
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import moment from "moment";
import Datepicker from "vuejs-datepicker";
import Multiselect from "vue-multiselect";
import Loader from "../Components/Loader.vue";

export default {
    name: "complianceAutomation",
    components: { Datepicker, Multiselect, Loader },
    data: function () {
        return {
            selected_website: localStorage.selected_SOVWebsite,
            device: localStorage.selected_category,
            startDate: moment().format("YYYY-MM-DD"),
            oem_websites: [
                "https://www.inmac-wstore.com",
                "https://www.technoworld.com",
                "https://www.bechtle.com",
                "https://www.connection.com",
                "https://www.shi.com",
                "https://www8.hp.com/jp#commercial",
                "https://www.lenovo.com/jp#commercial",
                "https://b2b.lenovo.com.cn#commercial",
                "https://www.hpstore.cn#commercial",
                "https://www.nec-lavie.jp",
                "https://fmv.fccl.fujitsu.com",
                "https://www.dell.com/ja-jp",
                "https://www.dell.com/en-au",
                "https://www.lenovo.com/au",
                "https://br-store.acer.com",
                "https://s.lenovo.com.cn",
                "https://store.hp.com/FranceStore",
                "https://store.hp.com/mx-es",
                "https://www.lenovo.com/fr",
                "https://www.insight.com/en-US",
                "https://store.hp.com/FranceStore#commercial",
                "https://www.lenovo.com/fr#commercial",
                "https://www.cdw.com",
                "https://www.lenovo.com/gb#commercial",
                "https://store.hp.com/UKStore#commercial",
                "https://www.lenovo.com/de#commercial",
                "https://store.hp.com/GermanyStore#commercial",
                "https://www8.hp.com/jp",
                "https://store.hp.com/us#commercial",
                "https://www.lenovo.com/us#commercial",
                "https://store.hp.com/UKStore",
                "https://store.hp.com/us",
                "https://www.asus.com/fr",
                "https://store.asus.com/us",
                "https://www.dell.com/en-us",
                "https://store.acer.com/en-us",
                "https://www.lenovo.com/us",
                "https://www.lenovo.com/gb",
                "https://www.lenovo.com/de",
            ],
            cpuGpuSites: [
                'https://www.amazon.com',
                'https://www.microcenter.com',
                'https://www.newegg.com',
                'https://www.bestbuy.com'
            ],
            columns_details: [],
            rows: [],
            rows_details: [],
            page: 1,
            rows_details_full: [],
            loader: false,
            spiderLoader: false,
            deviceMapper: {
                laptop: "PC",
                desktop: "Desktop",
                cpu: "CPU",
                gpu: "GPU"
            },
            isDataEditable: false,
            editedTableData: {},
            editedTableArr: [],
            selectedItemID: -1,
            logoMatchingStatus: {},
            noData: false,
            selectedTranslateFields: []
        };
    },

    mounted() {
        if (localStorage.selected_SOVWebsite) this.selected_website = localStorage.selected_SOVWebsite;
        else this.selected_website = "https://www.bestbuy.com";
        if (localStorage.selected_category) this.device = localStorage.selected_category;
        else this.device = "laptop";
        this.spider_details()
        this.$nextTick(() => {
            this.initDt2();
        })
    },
    methods: {
        preventRefresh() {
            if (this.editedTableArr.length) {
                const checkRefresh = confirm("You have values to updated, are you sure you want to proceed?");

            }
        },
        exportNow() {
            let self = this;
            self.loader = true;
            let payload = {};
            // let header = [];
            // for (let [idx, dataset] of self.columns_details.entries()) {
            //     let obj = {};
            //     obj["key"] = dataset.key;
            //     obj["label"] = dataset.label;
            //     header.push(obj);
            // }
            // payload.header = header;
            // payload.data = [];
            // let dtData = $("#compliance-automation-table")
            //     .DataTable()
            //     .rows({ filter: "applied" })
            //     .data();
            // $.each(dtData, function (index, value) {
            //     let obj = {};
            //     for (let [idx, dataset] of self.columns_details.entries()) {
            //         obj[dataset.key] = value[idx].replace(/<(.|\n)*?>/g, "");
            //     }
            //     payload.data.push(obj);
            // });
            payload.header = this.columns_details;
            payload.header.push({
                key: "link",
                label: "Product Link"
            })
            payload.data = this.rows_details;
            payload.file_type = "compliance_automation";

            const url = "/api/websites/export";

            this.$http.post(url, payload).then(
                (response) => {
                    self.loader = false;
                    window.location = response.body.file;
                },
                (err) => {
                    self.loader = false;
                }
            );
        },
        refresh() {
            $("#compliance-automation-table").DataTable().destroy();
            localStorage.selected_SOVWebsite = this.selected_website;
            localStorage.selected_category = this.device;
            this.spider_details();
            this.isDataEditable = false;
        },
        getStatus() {
            this.loader = true;
            const url = `/api/v1/logomatching/status?date=${this.startDate}&website=${this.selected_website}`;
            this.logoMatchingStatus = {};
            this.$http.get(url).then(
                (response) => {
                    if (Object.keys(response.body.data).length) {
                        this.logoMatchingStatus = response.body.data;
                    }
                    this.loader = false;
                },
                (err) => {
                    self.loader = false;
                    this.loader = false
                }
            );
        },
        translateData() {
            this.loader = true;
            const url = "/api/spider/translatedetails-en"
            const payload = {
                website: this.selected_website,
                timestamp: this.startDate,
                item_category: this.device,
                fields: this.selectedTranslateFields.map(field => field.key)
            };

            this.$http.post(url, payload).then(res => {
                this.selectedTranslateFields = [];
                this.spider_details();
                this.loader = false;
            }).catch(err => {
                console.log(err);
                this.loader = false;
            })
        },
        dumpData() {
            const url = "/api/spider/dump";
            let payload = {
                website: this.selected_website,
                timestamp: this.startDate,
                item_category: this.device
            }

            let confirmDump = confirm("Please confirm to dump.");

            if (confirmDump) {
                this.loader = true;
                this.$http.post(url, payload).then(
                    (response) => {
                        this.loader = false;
                        if (response.body.status === 200) {
                            this.$bvToast.toast(`Data dump succeeded`, {
                                autoHideDelay: 3000,
                                variant: "success"
                            });
                        }
                    },
                    (err) => {
                        this.loader = false;
                        this.$bvToast.toast(err.message, {
                            autoHideDelay: 3000,
                            variant: "danger"
                        });
                    }
                );
            } else return;
        },
        spider_details() {
            let self = this;
            self.spiderLoader = true;
            this.rows_details = [];
            this.rows_details_full = [];
            let payload = {
                website: this.selected_website,
                timestamp: this.startDate,
                item_category: this.device
            };

            const url = "/api/spider/showdetails";
            this.$http.post(url, payload).then(
                (response) => {
                    self.spiderLoader = false;
                    this.columns_details = response.data.data.headers;
                    this.rows_details = response.data.data.data;
                    this.getStatus()
                    self.$nextTick(function () {
                        self.initDt2();
                    });
                },
                (err) => {
                    self.spiderLoader = false;
                }
            );
        },

        changeCustomDate() {
            if (this.startDate) this.startDate = moment(this.startDate).format("YYYY-MM-DD");
        },
        processEditableTableData(rowData, id) {
            this.editedTableData = {};
            if (id === this.selectedItemID) this.isDataEditable = false;
            else this.isDataEditable = true;
            if (this.isDataEditable) {
                this.selectedItemID = id;
                this.editedTableData = { ...rowData };
            } else {
                this.selectedItemID = -1;
                this.editedTableData = [];
            }
        },

        saveEditedTableData(id) {
            if (this.selectedItemID !== id) {
                this.$bvToast.toast(`wrong save button`, {
                    autoHideDelay: 5000,
                    variant: "danger",
                });
                return false;
            } else {
                this.editedTableArr = [...this.editedTableArr, { ...this.editedTableData }];
                this.isDataEditable = false;
                this.postEditedTableData();
            }
        },

        deleteTableRow(row) {
            if (confirm("Sure to delete this row?")) {
                // this.loader = true;
                const url = "/api/spider/deletedetailscom";

                const payload = {
                    timestamp: this.startDate,
                    old_data: [row]
                }


                this.$http.post(url, payload).then(res => {
                    this.$bvToast.toast(`Row Deleted`, {
                        title: 'Weavr Sense',
                        autoHideDelay: 5000,
                        variant: "success",
                        toaster: 'b-toaster-top-right',
                    });
                    this.loader = false;
                    this.spider_details();
                }).catch(err => {
                    console.log(err);
                    this.$bvToast.toast(`Error: ${err}`, {
                        title: 'Weavr Sense',
                        autoHideDelay: 5000,
                        variant: "danger",
                        toaster: 'b-toaster-top-right',
                    });
                    this.loader = false;
                })
            }

        },

        postEditedTableData() {
            this.loader = true;
            const url = "/api/spider/updatedetails";
            const payload = {
                timestamp: this.startDate,
                old_data: this.editedTableArr,
            };

            this.$http.post(url, payload).then(
                (response) => {
                    this.$bvToast.toast(`Fields updated`, {
                        autoHideDelay: 5000,
                        variant: response.status ? "success" : "danger",
                    });
                    this.editedTableArr = [];
                    this.$nextTick(() => {
                        this.refresh();
                    });
                },
                (err) => {
                    this.isDataEditable = false;
                    this.$bvToast.toast(err.message, {
                        autoHideDelay: 5000,
                        variant: "danger",
                    });
                    this.editedTableArr = [];
                }
            );
        },

        initDt2() {
            let self = this;
            $("#compliance-automation-table").DataTable({
                language: {
                    search: "",
                    paginate: {
                        first: "",
                        previous: "<",
                        next: ">",
                        last: "",
                    },
                    lengthMenu: "<h5>Show entries</h5> _MENU_",
                },
                pagingType: "full_numbers",
                initComplete: function () {
                    this.api()
                        .columns()
                        .every(function () {
                            var column = this;

                            var select = $('<select><option value="">All</option></select>')
                                .appendTo($(column.footer()).empty())
                                .on("change", function () {
                                    var val = $.fn.dataTable.util.escapeRegex($(this).val());

                                    column.search(val ? "^" + val + "$" : "", true, false).draw();
                                });
                            let arr = [];
                            let sortedArr = [];
                            column
                                .data()
                                .unique()
                                .sort()
                                .each(function (d, j) {
                                    var myVal = $(d).text();
                                    arr.push(myVal);
                                });

                            sortedArr = arr.sort((a, b) =>
                                a.localeCompare(b, navigator.languages[0] || navigator.language, {
                                    numeric: true,
                                    ignorePunctuation: true,
                                })
                            );

                            for (let [idx, ds] of sortedArr.entries()) {
                                select.append('<option value="' + ds + '">' + ds + "</option>");
                            }
                        });
                },
                sorting: [[12, "asc"], [13, "asc"]]
            });

            var search = require("../../../public/Icons_SVG/Search.svg");
            $("#compliance-automation-table").wrap(
                "<div class='scrolledDataTable'></div>"
            );
            $("#compliance-automation-table_filter > label > input").attr(
                "placeholder",
                "Search"
            );
            $("#compliance-automation-table_filter > label").append(
                `<div class='search_icon'><img src='${search}' /></div>`
            );
            $("#compliance-automation-table_length > label > select").removeClass();
        },
    },
};
</script>
  
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
#compliance-automation-table_filter>label {
    display: flex;
    flex-direction: row;
    justify-content: end;
}

#compliance-automation-table_filter input {
    border-radius: 5px 0 0 5px !important;
    height: 35px;
    width: 220px;
    margin-bottom: 8px;
    outline: none;
    border-color: var(--primary_brand-60);
    border-right: none;
    padding: 10px 15px !important;
}

#compliance-automation-table_filter input:focus {
    border-color: var(--primary_brand) !important;
    outline: none !important;
    box-shadow: none !important;
}

#compliance-automation-table_filter input::placeholder {
    color: var(--primary_brand-40) !important;
}

#compliance-automation-table_filter input:-ms-input-placeholder {
    color: var(--primary_brand-40) !important;
}

#compliance-automation-table_filter input::-ms-input-placeholder {
    color: var(--primary_brand-40) !important;
}

#compliance-automation-table .page-item:focus {
    border: none !important;
    outline: none !important;
    box-shadow: none !important;
    box-shadow: none;
}

div#compliance-automation-table_filter {
    display: flex;
    justify-content: end;
}

#compliance-automation-table_filter div.search_icon {
    height: 35px;
    width: 35px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 5px;
    margin-left: -14px;
    background-color: var(--primary_brand);
}

#compliance-automation-table_filter div.search_icon img {
    height: 17px;
    filter: invert(97%) sepia(67%) saturate(13%) hue-rotate(242deg) brightness(103%) contrast(104%);
}

#compliance-automation-table_filter div.filter_icon {
    height: 35px;
    width: 35px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 5px;
    cursor: pointer;
    background-color: var(--background);
}

#compliance-automation-table_filter div.filter_icon img {
    height: 23px;
    filter: brightness(0) saturate(100%) invert(24%) sepia(18%) saturate(2530%) hue-rotate(138deg) brightness(98%) contrast(95%);
}

#compliance-automation-table_paginate {
    position: relative;
    top: 12px;
    z-index: 100;
    float: right;
    width: 50vw;
}

#compliance-automation-table_info {
    position: relative;
    top: 9px;
    left: 324px;
    z-index: 100;
    float: right;
    width: 50vw;
    font-size: 15px;
    /* font-weight: 600; */
    color: var(--primary_brand-80);
}

#compliance-automation-table_length {
    /* position: relative;
    top: 90px;
    left: 30px;
    z-index: 100;
    width: 50vw; */
}

#compliance-automation-table_length label {
    border-style: solid;
    border-width: thin;
    padding: 0 5px;
    height: 35px;
    border-radius: 5px;
    width: 170px;
    border-color: var(--primary_brand-40);
    display: flex;
    justify-content: space-between;
}

#compliance-automation-table_length h5 {
    width: fit-content;
    text-align: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-transform: none;
    padding: 10px 0 10px 10px;
    font-size: 15px;
    color: var(--primary_brand-80);
    margin: 0;
}

#compliance-automation-table_length select {
    width: 30px;
    height: 100%;
    text-align-last: center;
    border-radius: 5px;
    margin-right: 10px !important;
    -webkit-appearance: none !important;
    -moz-appearance: none !important;
    appearance: none !important;
    border-color: var(--primary_brand-40) !important;
    background-color: #fff !important;
    color: var(--primary_brand-80);
}

#compliance-automation-table_paginate .page-link {
    border: none !important;
    background: none !important;
    color: var(--primary_brand-80) !important;
}

#compliance-automation-table_paginate ul.pagination li.active {
    border: 1px solid var(--primary_brand-40) !important;
    border-radius: 7px;
    box-shadow: none !important;
}

#compliance-automation-table {
    border-radius: 20px 20px 0 0;
}

#compliance-automation-table .thead-normal,
#compliance-automation-table .thead-normal tr,
#compliance-automation-table .thead-normal>tr>th:first-child {
    background-color: var(--background) !important;
    border-radius: 21px 0 0 0;
    border-left: 1px solid var(--base_color-20) !important;
}

#compliance-automation-table .thead-normal>tr>th:last-child {
    border-radius: 0 21px 0 0;
}

#compliance-automation-table .thead-normal>tr>th {
    font-size: 14px;
    letter-spacing: 0.1px;
    font-weight: 300 !important;
    text-align: center !important;
    padding: 5px 25px;
    color: rgb(78 78 78) !important;
    border-top: 1px solid var(--base_color-20) !important;
    border-right: 1px solid var(--base_color-20) !important;
}

#compliance-automation-table .thead-normal>tr>th.sorting:before {
    font-size: 15px;
    bottom: 57%;
    color: var(--base_color-80);
}

#compliance-automation-table .thead-normal>tr>th.sorting:after {
    /* top: -40%; */
    font-size: 15px;
    color: var(--base_color-80);
}

#compliance-automation-table th select {
    background-color: #fff !important;
    filter: brightness(99%);
    border: 1px solid #b1b1b1 !important;
    width: 100%;
    color: var(--primary_brand-60);
    font-size: 10px;
    border-radius: 7px;
    height: 33px;
}

#compliance-automation-table tfoot th {
    background-color: var(--background) !important;
    border-right: 1px solid var(--base_color-20) !important;
    border-bottom: 1px solid var(--base_color-20) !important;
    padding: 5px !important;
}

#compliance-automation-table tfoot th:first-child {
    background-color: var(--background) !important;
    border-left: 1px solid var(--base_color-20) !important;
    padding: 5px !important;
}

#compliance-automation-table tbody td {
    border-right: 1px solid var(--base_color-20) !important;
    border-bottom: 1px solid var(--base_color-20) !important;

    font-size: 13px !important;
    font-family: "Heebo", sans-serif !important;
}

#compliance-automation-table tbody td:first-child {
    border-left: 1px solid var(--base_color-20) !important;
}

#compliance-automation-table .even td {
    /* background: #fff !important; */
}

#compliance-automation-table .odd td {
    /* background: #fff !important; */
    /* filter: brightness(110%); */
}

/* #compliance-automation-table_wrapper .bottom{
    margin: -30px;
  } */
#compliance-automation-table_wrapper>.row:last-child {
    margin-bottom: 15px;
}

#compliance-automation-table_wrapper .scrolledDataTable {
    border-left: none;
    border-right: none;
}

#compliance-automation-table_wrapper .scrolledDataTable::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px rgba(203, 203, 203, 0.3);
    border-radius: 10px;
    background: var(--base_color-10);
}

#compliance-automation-table_wrapper .scrolledDataTable::-webkit-scrollbar {
    height: 10px;
}

#compliance-automation-table_wrapper .scrolledDataTable::-webkit-scrollbar-thumb {
    border-radius: 10px;
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    background: var(--base_color-40);
}

#compliance-automation-table_wrapper .scrolledDataTable::-webkit-scrollbar-thumb:hover {
    background: var(--base_color-60);
}
</style>
  
<style scoped>
#sovdetailed {
    font-family: "Poppins", sans-serif !important;
}

.checkbox-btn {
    margin-right: 6px;
    height: 35px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border: none;
    background-color: var(--base_color-10);
    border-radius: 5px;
    color: #000;
    padding: 0px 10px;
}

.checkbox-btn span {
    padding: 0 5px;
}

.checkbox-btn input {
    margin: 4px;
    font-size: 11px;
    width: 15px;
    height: 15px;
    accent-color: #fff;
}

.revampCard {
    border-radius: 0.7rem !important;
    border: none !important;
    margin-bottom: 1.5rem;
}

.exportButton:hover {
    color: white !important;
    background: var(--primary_brand-80) !important;
    font-family: "poppins";
}

.customSelect :focus {
    background: var(--base_color-5);
    color: var(--primary_brand-60);
    border: 1px solid var(--primary_brand-60) !important;
    outline: none;
    box-shadow: none;
    font-weight: 600;
}

select {
    font-family: "Poppins", sans-serif;
}

button.primarycolor {
    background: var(--primary_brand);
    font-family: "Poppins", sans-serif;
    color: white;
    padding: 5px 25px;
    border-radius: 6px;
    letter-spacing: 0.2px;
    font-weight: bold;
    font-size: 16px;
}

button.primarycolor:hover {
    color: white;
    background: var(--primary_brand-80);
    /* border: 1.6px solid var(--base_color); */
}

button.green {
    background: var(--green);
    font-family: "Poppins", sans-serif;
    color: white;
    padding: 5px 25px;
    border-radius: 6px;
    letter-spacing: 0.2px;
    font-weight: bold;
    font-size: 16px;
}

button.green:hover {
    color: white;
    background: var(--green-80);
    /* border: 1.6px solid var(--base_color); */
}

button.red {
    background: var(--red);
    font-family: "Poppins", sans-serif;
    color: white;
    padding: 5px 25px;
    border-radius: 6px;
    letter-spacing: 0.2px;
    font-weight: bold;
    font-size: 16px;
}

button.red:hover {
    color: white;
    background: var(--red-80);
    /* border: 1.6px solid var(--base_color); */
}

.navigationButton {
    height: 35px;
    border: none;
    margin: 0;
    background: var(--accent_color);
    color: white;
    border-radius: 5px;
    font-size: 16px;
    font-weight: bold;
    padding: 0px 20px;
    letter-spacing: 0.2px;
    font-family: "poppins";
}

.navigationButton:hover {
    background: var(--accent_color-80);
}

.form-control {
    border-radius: 5px !important;
    padding: 6px !important;
    font-size: 11px !important;
    height: 35px !important;
    border: 1px solid var(--base_color-40) !important;
}

.exportButton {
    margin-left: 6px;
    height: 35px;
    border: none;
    background: var(--primary_brand);
    color: white;
    border-radius: 5px;
    font-weight: 600;
    padding: 0px 25px;
    letter-spacing: 0.2px;
}

.graphHeading {
    font-weight: 600 !important;
    font-size: 20px !important;
    color: var(--primary_brand) !important;
    letter-spacing: 0.6px !important;
    margin-bottom: -20px !important;
}

.backIcon {
    filter: brightness(0) saturate(100%) invert(98%) sepia(0%) saturate(206%) hue-rotate(268deg) brightness(116%) contrast(100%);
}

input.textInput {
    border-radius: 5px !important;
    outline: none;
}

input.textInput:focus {
    border-color: var(--primary_brand-60) !important;
    outline: none !important;
    box-shadow: none !important;
}

/* ---------- pre-revamp styles ----------- */

.custom-table {
    padding: 10px;
    margin: 10px;
}

.markitamd {
    background-color: var(--primary_client-20) !important;
}

.markitintel {
    background-color: var(--primary_competitor-10) !important;
}

.markitsnap {
    background-color: var(--pink-20) !important;
}

.markitna {
    background-color: var(--olive-20) !important;
}

.markittek {
    background-color: var(--accent_color-20) !important;
}

.space-between-header {
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid #c1c1c1;
    margin-bottom: 10px;
    padding-left: 5px;
    padding-right: 7px;
    padding-bottom: 5px;
}

.space-between-header select {
    width: fit-content;
    float: right;
    border: 1px solid #c5c5c5;
}

.space-between-header h3 {
    color: #533a79;
    margin-bottom: 0;
    line-height: 31px;
}

.listing-custom {
    font-size: 18px;
    margin-bottom: 6px;
    text-align: center;
    width: 215px;
    background: #8a87e8;
}

.hint {
    cursor: pointer;
    background: #f5f5f5;
    color: #080808;
    padding: 3px;
    font-size: 9px;
}

.amd-legend {
    text-align: center;
    position: absolute;
    left: 15%;
    right: 15%;
    z-index: 9;
}

.amd-legend i {
    width: fit-content;
}

.amd-legend span {
    padding-left: 4px;
    font-size: 12px;
}

.legending {
    display: flex;
    align-items: center;
    margin-right: 19px;
}

#avgTable th,
#avgTable td {
    border: 1px solid #c8ced3 !important;
    text-align: left;
    font-size: 14px;
}

.mycols:first-child {
    padding-right: 2px !important;
}

.mycols:last-child {
    padding-left: 2px;
}

.mycols:not(:first-child):not(:last-child) {
    padding-left: 2px;
    padding-right: 2px;
}

input.filval,
button.filval {
    border-radius: 0;
    padding: 6px;
    height: 30px;
}

input.filval {
    padding-top: 5px;
}

button.filval {
    padding-top: 3px;
}

.filter .row {
    justify-content: center;
}

.filter select,
input.filval {
    border: 1px solid silver;
}

.custom_dropdown {
    text-transform: uppercase;
    -youbkit-touch-callout: none;
    /* iOS Safari */
    -youbkit-user-select: none;
    /* Chrome 6.0+, Safari 3.1+, Edge & Opera 15+ */
    -moz-user-select: none;
    /* Firefox */
    -ms-user-select: none;
    /* IE 10+ and Edge */
    user-select: none;
}
.redbg {
  background: #ffd1d1;
  color: inherit
}
</style>
<style>
.customMultiselect .multiselect__placeholder {
    margin-bottom: 6px !important;
    padding: 0px !important;
    color: var(--primary_brand-40) !important;
    font-family: "poppins";
}

.customMultiselect .multiselect__tags {
    border: 1px solid var(--base_color-40) !important;
    padding-top: 6px !important;
    min-height: 35px !important;
    max-height: 36px !important;
    overflow-y: auto;
    font-family: "poppins";
}

.customMultiselect .multiselect__input {
    border: var(--base_color-20) !important;
    height: 30px !important;
}

.customMultiselect .multiselect__input:focus {
    outline: none !important;
}

.customMultiselect .multiselect__select {
    min-height: 35px !important;
    font-family: "poppins";
}

.customMultiselect .multiselect__select::before {
    top: 56% !important;
    font-family: "poppins";
}

.customMultiselect .multiselect__tag {
    background: var(--primary_brand-80) !important;
    margin-bottom: 0px !important;
    font-family: "poppins";
}

.customMultiselect .multiselect__tag-icon:after {
    color: #fff !important;
    font-family: "poppins";
}

.customMultiselect .multiselect__content-wrapper {
    border: 1px solid var(--base_color-40) !important;
    border-top: none !important;
    font-family: "poppins";
}

.customMultiselect .multiselect__option--selected.multiselect__option--highlight {
    background: var(--red) !important;
    color: var(--white) !important;
    font-family: "poppins";
}

.customMultiselect .multiselect__option--highlight {
    background: var(--base_color-20) !important;
    color: var(--primary_brand-80) !important;
    font-family: "poppins";
}

.customMultiselect .multiselect__element {
    color: var(--primary_brand-80) !important;
    border-bottom: 1px solid var(--base_color-20);
    font-family: "poppins";
}

.customMultiselect .multiselect__option--group {
    background-color: #44777A !important;
    color: white !important;
    font-size: 16px;
}

.customMultiselect .multiselect__option--highlight::after {
    font-size: 10px !important;
    padding-inline: 6px !important;
}

/* width */
.customMultiselect ::-webkit-scrollbar {
    width: 10px;
    border-radius: 10px;
}

/* Track */
.customMultiselect ::-webkit-scrollbar-track {
    background: var(--base_color-20);
    border-radius: 10px;
}

/* Handle */
.customMultiselect ::-webkit-scrollbar-thumb {
    background: var(--base_color-80);
    border-radius: 10px;
}

/* Handle on hover */
.customMultiselect ::-webkit-scrollbar-thumb:hover {
    background: var(--base_color);
}
</style>
